import { PageProps } from 'gatsby';
import React, { useEffect } from 'react';

import { Box, Stack } from '@mui/material';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { AnalyticsPageType } from '@shopify/hydrogen-react';
import { ShopPolicy } from '@shopify/hydrogen-react/storefront-api-types';

import SeoHead from '../../components/head';
import { HorizontalSlantContainer } from '../../components/horizontal-slant-container';
import { useAnalytics } from '../../shared/analytics';
import { headerSlantContainerNoContent } from '../../shared/styles/headerSlantContainer';

export default function ShopifyPolicyPageTemplate(props: PageProps<unknown, ShopPolicy>) {
  const analytics = useAnalytics();
  const headerSlantContainerNoContentStyles = headerSlantContainerNoContent();
  useEffect(() => {
    analytics.trackPageView(AnalyticsPageType.policy);
  }, [])

  return (
    <>
      <HorizontalSlantContainer id={props.pageContext.id} autoHeight>
        <Container sx={headerSlantContainerNoContentStyles}></Container>
      </HorizontalSlantContainer>

      <Container sx={{ pt: 6 }}>
        <Stack spacing={2}>
          <Box>
            <Typography variant="h1" gutterBottom>
              {props.pageContext.title}
            </Typography>
          </Box>

          <Container>
            <Box
              dangerouslySetInnerHTML={{
                __html: props.pageContext.body,
              }}
            />
          </Container>
        </Stack>
      </Container>
    </>
  )
}

export const Head = (props: PageProps<unknown, ShopPolicy>) => {
  return <SeoHead title={props.pageContext.title} description={`Information on Blootropic\'s ${props.pageContext.title}`} pathname={props.location.pathname} />
}